// 妖精漫画网 - 模拟数据（仅用于页面展示，连接真实数据源后替换）

export interface MangaComic {
  id: string;
  title: string;
  author: string;
  tags: string[];
  status: string;
  rating: number;
  chapters: number;
  views: string;
  cover: string;
  description: string;
  latestChapter: string;
  updateTime: string;
  year: string;
}

export interface BookList {
  id: string;
  name: string;
  desc: string;
  cover: string;
  count: number;
  tag: string;
  owner: string;
  comicIds: string[];
}

export interface FaqItem {
  q: string;
  a: string;
}

export const categories = [
  { name: "热血冒险", icon: "ri-flashlight-fill", count: 128 },
  { name: "奇幻魔法", icon: "ri-magic-fill", count: 96 },
  { name: "恋爱日常", icon: "ri-heart-3-fill", count: 113 },
  { name: "悬疑推理", icon: "ri-search-eye-fill", count: 64 },
  { name: "科幻未来", icon: "ri-rocket-2-fill", count: 71 },
  { name: "搞笑治愈", icon: "ri-emotion-happy-fill", count: 102 },
  { name: "武侠历史", icon: "ri-sword-fill", count: 58 },
  { name: "校园成长", icon: "ri-book-3-fill", count: 87 },
];

export const hotTags = [
  "完结补番", "日常治愈", "热血", "奇幻", "恋爱", "悬疑", "科幻", "校园",
  "修仙", "国漫", "日漫", "已完结", "轻小说改", "群像", "战斗", "美食",
];

export const comics: MangaComic[] = [
  {
    id: "star-wanderer",
    title: "星渊旅人",
    author: "白夜航行社",
    tags: ["科幻", "冒险", "热血"],
    status: "连载中",
    rating: 9.6,
    chapters: 128,
    views: "286万",
    cover: "https://readdy.ai/api/search-image?query=dynamic%20anime%20key%20visual%20of%20a%20young%20explorer%20in%20a%20gleaming%20space%20suit%20floating%20before%20a%20glowing%20nebula%2C%20warm%20coral%20and%20teal%20cosmic%20palette%2C%20vibrant%20cinematic%20lighting%2C%20clean%20minimal%20dark%20backdrop%2C%20high%20detail%20illustration&width=600&height=800&seq=manga-cover-01&orientation=portrait",
    description: "少年拓荒者意外觉醒「星轨之力」，在无数神秘星域间穿行，追逐失落的故乡坐标。宏大的星际冒险、并肩作战的伙伴与逐渐揭开的宇宙谜团交织成一部燃向科幻长卷。",
    latestChapter: "第128话 归途的星光",
    updateTime: "今天 09:20",
    year: "2024",
  },
  {
    id: "shanhai-spirits",
    title: "山海妖闻录",
    author: "青丘画师",
    tags: ["奇幻", "国漫", "群像"],
    status: "连载中",
    rating: 9.4,
    chapters: 96,
    views: "215万",
    cover: "https://readdy.ai/api/search-image?query=anime%20girl%20in%20traditional%20chinese%20dress%20with%20a%20fox%20spirit%20companion%2C%20floating%20warm%20lanterns%20and%20ink%20wash%20mountains%2C%20autumn%20golden%20tones%2C%20mythical%20storybook%20illustration%2C%20elegant%20brush%20style%20backdrop&width=600&height=800&seq=manga-cover-02&orientation=portrait",
    description: "少女书灵行走于《山海经》所载的奇兽异界，与上古神兽结契同行，修补被岁月打乱的万物秩序。一幅水墨丹青下的东方奇幻长卷徐徐展开。",
    latestChapter: "第96话 山海之间",
    updateTime: "昨天 22:15",
    year: "2024",
  },
  {
    id: "misty-night",
    title: "雾都守夜人",
    author: "檐下灯",
    tags: ["悬疑", "冒险", "群像"],
    status: "已完结",
    rating: 9.2,
    chapters: 64,
    views: "168万",
    cover: "https://readdy.ai/api/search-image?query=anime%20cloaked%20night%20guardian%20standing%20on%20a%20rainy%20rooftop%20in%20a%20foggy%20city%2C%20moody%20amber%20streetlights%2C%20neon%20mist%2C%20noir%20atmosphere%2C%20warm%20orange%20accents%2C%20dramatic%20illustration&width=600&height=800&seq=manga-cover-03&orientation=portrait",
    description: "永夜之城笼罩不散之雾，神秘的守夜人组织世代守护城市的边界。当新一任守夜人接过燃灯，藏在浓雾背后的真相逐渐浮出水面。",
    latestChapter: "第64话 破晓",
    updateTime: "昨天 18:40",
    year: "2023",
  },
  {
    id: "quantum-academy",
    title: "量子学院",
    author: "粒子编辑部",
    tags: ["科幻", "校园", "搞笑"],
    status: "连载中",
    rating: 9.1,
    chapters: 110,
    views: "197万",
    cover: "https://readdy.ai/api/search-image?query=anime%20students%20in%20sci%20fi%20academy%20uniform%20with%20holographic%20gadgets%2C%20bright%20warm%20futuristic%20campus%2C%20energetic%20and%20playful%2C%20golden%20sunlight%2C%20clean%20vibrant%20key%20visual&width=600&height=800&seq=manga-cover-04&orientation=portrait",
    description: "一群问题学生被编入传说中的「量子学院」实验班，用奇葩的脑洞解决一个个时空难题。爆笑日常与硬核科幻齐飞，越看越上头。",
    latestChapter: "第110话 平行线",
    updateTime: "昨天 11:05",
    year: "2024",
  },
  {
    id: "moonlit-street",
    title: "月隐街拾遗",
    author: "拾荒者KiKi",
    tags: ["奇幻", "治愈", "日常"],
    status: "连载中",
    rating: 9.5,
    chapters: 82,
    views: "143万",
    cover: "https://readdy.ai/api/search-image?query=cozy%20anime%20shopkeeper%20among%20mystical%20artifacts%20in%20a%20warm%20night%20market%2C%20golden%20lanterns%20and%20soft%20glow%2C%20comforting%20slice%20of%20life%20atmosphere%2C%20muted%20warm%20palette%2C%20detailed%20illustration&width=600&height=800&seq=manga-cover-05&orientation=portrait",
    description: "每逢月隐之日，一条只属于妖怪与人类共同赶集的老街便会浮现。器物会说话，回忆能买卖，店主用一件件旧物拼起来访者心底最柔软的角落。",
    latestChapter: "第82话 旧日的钟",
    updateTime: "今天 07:30",
    year: "2024",
  },
  {
    id: "wind-changan",
    title: "风起长安",
    author: "醉剑客",
    tags: ["武侠", "历史", "热血"],
    status: "连载中",
    rating: 9.3,
    chapters: 75,
    views: "124万",
    cover: "https://readdy.ai/api/search-image?query=anime%20swordsman%20in%20ancient%20chinese%20robes%20with%20flowing%20sash%2C%20drifting%20petals%20and%20warm%20sunset%2C%20epic%20wuxia%20hero%20pose%2C%20golden%20warm%20palette%2C%20cinematic%20key%20visual%20illustration&width=600&height=800&seq=manga-cover-06&orientation=portrait",
    description: "大唐长安，暗流涌动。一名身负血仇的少年剑客踏入繁华帝都，在江湖与庙堂的夹缝中，一步步揭开笼罩天下的惊天棋局。",
    latestChapter: "第75话 长安夜",
    updateTime: "3天前",
    year: "2023",
  },
  {
    id: "deep-blue",
    title: "深蓝谜境",
    author: "海雾工作室",
    tags: ["奇幻", "冒险", "治愈"],
    status: "连载中",
    rating: 8.9,
    chapters: 51,
    views: "86万",
    cover: "https://readdy.ai/api/search-image?query=anime%20girl%20diver%20exploring%20luminous%20underwater%20ruins%2C%20teal%20and%20gold%20light%20rays%20through%20clear%20water%2C%20bubbles%2C%20wondrous%20tranquil%20mood%2C%20vibrant%20illustration&width=600&height=800&seq=manga-cover-07&orientation=portrait",
    description: "海底深处藏着沉没的文明与发光的谜境。立志成为海洋考古师的少女，在一次意外中听见了来自深蓝之下的呼唤。",
    latestChapter: "第51话 海之眼",
    updateTime: "4天前",
    year: "2024",
  },
  {
    id: "cat-manager",
    title: "猫掌柜日记",
    author: "布丁阿喵",
    tags: ["搞笑", "治愈", "日常"],
    status: "已完结",
    rating: 9.7,
    chapters: 143,
    views: "320万",
    cover: "https://readdy.ai/api/search-image?query=cute%20anime%20cat%20mascot%20wearing%20a%20tiny%20cafe%20apron%20in%20a%20cozy%20pastry%20shop%2C%20soft%20pastel%20orange%20and%20cream%2C%20warm%20comforting%20light%2C%20adorable%20kawaii%20illustration&width=600&height=800&seq=manga-cover-08&orientation=portrait",
    description: "一只会做甜点的橘猫继承了街角的小店，每天迎来送往形形色色的客人。没有跌宕起伏的大事件，只有治愈到冒泡的温馨日常。",
    latestChapter: "第143话 谢谢光临",
    updateTime: "1周前",
    year: "2022",
  },
  {
    id: "dawn-knight",
    title: "破晓骑士",
    author: "晨曦骑士团",
    tags: ["热血", "战斗", "奇幻"],
    status: "连载中",
    rating: 9.0,
    chapters: 68,
    views: "139万",
    cover: "https://readdy.ai/api/search-image?query=anime%20armored%20knight%20holding%20a%20glowing%20sword%20at%20sunrise%2C%20heroic%20pose%2C%20warm%20orange%20dawn%20sky%2C%20majestic%20epic%20fantasy%20key%20visual%2C%20clean%20composition&width=600&height=800&seq=manga-cover-09&orientation=portrait",
    description: "当邪影再次笼罩大地，落魄骑士重新拾起象征破晓的圣剑。少年与少女的羁绊，在一次次浴血奋战中愈发坚不可摧。",
    latestChapter: "第68话 黎明之约",
    updateTime: "2天前",
    year: "2023",
  },
  {
    id: "time-hotel",
    title: "时间旅店",
    author: "时针先生",
    tags: ["奇幻", "悬疑", "治愈"],
    status: "连载中",
    rating: 9.4,
    chapters: 44,
    views: "92万",
    cover: "https://readdy.ai/api/search-image?query=anime%20clockwork%20hotel%20with%20vintage%20architecture%20and%20interior%20warm%20glow%2C%20gears%20and%20grandfather%20clocks%2C%20mysterious%20cozy%20atmosphere%2C%20amber%20gold%20tones%2C%20detailed%20illustration&width=600&height=800&seq=manga-cover-10&orientation=portrait",
    description: "一家只接待「错过时光的人」的旅店。每间客房都通往一段被遗憾封存的过往，住客得以暂居其中，重新面对难以放下的瞬间。",
    latestChapter: "第44话 归途房客",
    updateTime: "5天前",
    year: "2024",
  },
  {
    id: "spirit-contract",
    title: "万灵契约",
    author: "符咒社",
    tags: ["奇幻", "热血", "修仙"],
    status: "连载中",
    rating: 8.8,
    chapters: 57,
    views: "77万",
    cover: "https://readdy.ai/api/search-image?query=anime%20mage%20summoning%20a%20glowing%20spirit%20with%20rune%20circles%2C%20dark%20backdrop%20with%20warm%20gold%20magic%20glow%2C%20mystical%20contract%20magic%2C%20dramatic%20lighting%2C%20high%20detail%20illustration&width=600&height=800&seq=manga-cover-11&orientation=portrait",
    description: "万物有灵，皆可缔约。落魄符师与千年灵兽立下生死契约，从此踏上收服万灵的征途，也揭开了自己身世之谜的冰山一角。",
    latestChapter: "第57话 契约之心",
    updateTime: "1天前",
    year: "2024",
  },
  {
    id: "lone-city-escort",
    title: "孤城镖师",
    author: "关外风",
    tags: ["武侠", "热血", "冒险"],
    status: "已完结",
    rating: 8.7,
    chapters: 49,
    views: "65万",
    cover: "https://readdy.ai/api/search-image?query=anime%20martial%20arts%20escort%20guard%20on%20a%20desert%20road%20under%20warm%20sand%20tones%2C%20determined%20expression%2C%20distant%20walled%20city%2C%20epic%20western%20wuxia%20mood%2C%20golden%20hour%20lighting%2C%20illustration&width=600&height=800&seq=manga-cover-12&orientation=portrait",
    description: "大漠孤烟，一队镖车孤独前行。失去家园的年轻镖师扛起走镖的使命，在漫天黄沙中守护比黄金更珍贵的承诺。",
    latestChapter: "第49话 归鸿",
    updateTime: "2周前",
    year: "2022",
  },
  {
    id: "spring-etude",
    title: "春日练习曲",
    author: "音阶社",
    tags: ["恋爱", "校园", "治愈"],
    status: "连载中",
    rating: 9.2,
    chapters: 36,
    views: "58万",
    cover: "https://readdy.ai/api/search-image?query=anime%20music%20student%20playing%20violin%20in%20a%20blooming%20park%2C%20fresh%20warm%20spring%20light%2C%20cherry%20blossoms%2C%20gentle%20romantic%20mood%2C%20soft%20peach%20palette%2C%20delicate%20illustration&width=600&height=800&seq=manga-cover-13&orientation=portrait",
    description: "为了参加全国校园音乐节，性格迥异的两个人被迫组成二重奏。从频繁的争执到逐渐合拍，青春的心动也在一次次排练中悄然萌芽。",
    latestChapter: "第36话 同频",
    updateTime: "今天 14:00",
    year: "2025",
  },
  {
    id: "home-lamps",
    title: "归途灯火",
    author: "暖居社",
    tags: ["日常", "治愈", "奇幻"],
    status: "已完结",
    rating: 9.3,
    chapters: 52,
    views: "104万",
    cover: "https://readdy.ai/api/search-image?query=anime%20traveler%20walking%20on%20a%20snowy%20street%20toward%20warm%20lit%20houses%2C%20comforting%20cozy%20mood%2C%20snowfall%20and%20amber%20window%20lights%2C%20nostalgic%20heartwarming%20illustration&width=600&height=800&seq=manga-cover-14&orientation=portrait",
    description: "每到年关，山间小城的灯火总会为远行的人点亮。失去方向的旅人循着零星灯火，在陌生人的故事里重新找回家的意义。",
    latestChapter: "第52话 万家灯火",
    updateTime: "1月前",
    year: "2023",
  },
  {
    id: "mechanical-heart",
    title: "机械之心",
    author: "齿轮工坊",
    tags: ["科幻", "战斗", "热血"],
    status: "连载中",
    rating: 8.9,
    chapters: 61,
    views: "83万",
    cover: "https://readdy.ai/api/search-image?query=anime%20girl%20with%20a%20mechanical%20robotic%20arm%20in%20a%20warm%20steampunk%20workshop%2C%20gears%20and%20amber%20machinery%20glow%2C%20determined%20expression%2C%20detailed%20steampunk%20illustration&width=600&height=800&seq=manga-cover-15&orientation=portrait",
    description: "一场意外让机械师少女失去了左臂，也让她与一台神秘的古代机体建立连接。带着「机械之心」，她在机甲格斗联赛中一步步证明自己。",
    latestChapter: "第61话 钢铁意志",
    updateTime: "3天前",
    year: "2024",
  },
  {
    id: "paper-wonderland",
    title: "纸境奇缘",
    author: "折纸旅人",
    tags: ["奇幻", "治愈", "冒险"],
    status: "连载中",
    rating: 9.0,
    chapters: 29,
    views: "41万",
    cover: "https://readdy.ai/api/search-image?query=anime%20character%20stepping%20into%20a%20paper%20craft%20folded%20world%2C%20warm%20orange%20cutout%20paper%20style%2C%20whimsical%20and%20dreamy%2C%20folded%20landscapes%2C%20handmade%20texture%2C%20delightful%20illustration&width=600&height=800&seq=manga-cover-16&orientation=portrait",
    description: "能把折纸变成现实的少女，误入一个由纸张折叠而成的奇妙世界。在这里，想象力就是法则，而她需要用自己的折纸技巧完成一场盛大的冒险。",
    latestChapter: "第29话 折叠之城",
    updateTime: "今天 08:45",
    year: "2025",
  },
];

export const updates: { comicId: string; chapter: string; time: string }[] = [
  { comicId: "star-wanderer", chapter: "第128话 归途的星光", time: "今天 09:20" },
  { comicId: "spring-etude", chapter: "第36话 同频", time: "今天 14:00" },
  { comicId: "paper-wonderland", chapter: "第29话 折叠之城", time: "今天 08:45" },
  { comicId: "moonlit-street", chapter: "第82话 旧日的钟", time: "今天 07:30" },
  { comicId: "shanhai-spirits", chapter: "第96话 山海之间", time: "昨天 22:15" },
  { comicId: "misty-night", chapter: "第64话 破晓", time: "昨天 18:40" },
  { comicId: "quantum-academy", chapter: "第110话 平行线", time: "昨天 11:05" },
  { comicId: "spirit-contract", chapter: "第57话 契约之心", time: "1天前" },
];

export const booklists: BookList[] = [
  {
    id: "warm-heal",
    name: "治愈系·深夜回血书单",
    desc: "累了一天回到家，只想瘫着看点暖暖的东西。这份书单收录的每一部都自带治愈光环，适合通勤和睡前慢慢补。",
    cover: "https://readdy.ai/api/search-image?query=cozy%20anime%20shopkeeper%20among%20mystical%20artifacts%20in%20a%20warm%20night%20market%2C%20golden%20lanterns%20and%20soft%20glow%2C%20comforting%20slice%20of%20life%20atmosphere%2C%20muted%20warm%20palette%2C%20detailed%20illustration&width=600&height=800&seq=manga-cover-05&orientation=portrait",
    count: 18,
    tag: "治愈",
    owner: "灯火收藏家",
    comicIds: ["moonlit-street", "cat-manager", "home-lamps", "spring-etude", "deep-blue"],
  },
  {
    id: "hot-blood",
    name: "燃向热血·停不下来的爽漫",
    desc: "一口气追完不费劲！从星际远征到江湖对决，每一部都是节奏快、战斗燃、看完立刻想点下一话的硬货。",
    cover: "https://readdy.ai/api/search-image?query=dynamic%20anime%20key%20visual%20of%20a%20young%20explorer%20in%20a%20gleaming%20space%20suit%20floating%20before%20a%20glowing%20nebula%2C%20warm%20coral%20and%20teal%20cosmic%20palette%2C%20vibrant%20cinematic%20lighting%2C%20clean%20minimal%20dark%20backdrop%2C%20high%20detail%20illustration&width=600&height=800&seq=manga-cover-01&orientation=portrait",
    count: 26,
    tag: "热血",
    owner: "战斗狂魔",
    comicIds: ["star-wanderer", "wind-changan", "dawn-knight", "mechanical-heart", "spirit-contract"],
  },
  {
    id: "mystery",
    name: "悬疑烧脑·反转不断",
    desc: "喜欢猜凶手、挖伏笔的推理党必入。迷雾都市、时间旅店、深蓝谜境……每一部都藏着让你意想不到的真相。",
    cover: "https://readdy.ai/api/search-image?query=anime%20cloaked%20night%20guardian%20standing%20on%20a%20rainy%20rooftop%20in%20a%20foggy%20city%2C%20moody%20amber%20streetlights%2C%20neon%20mist%2C%20noir%20atmosphere%2C%20warm%20orange%20accents%2C%20dramatic%20illustration&width=600&height=800&seq=manga-cover-03&orientation=portrait",
    count: 14,
    tag: "悬疑",
    owner: "真相只有一个",
    comicIds: ["misty-night", "time-hotel", "deep-blue", "paper-wonderland"],
  },
  {
    id: "chinese-style",
    name: "国风美学·东方奇幻精选",
    desc: "水墨、武侠、山海经与长安城。这一份书单专门收录画面惊艳、故事厚重的国漫佳作，东方韵味直接拉满。",
    cover: "https://readdy.ai/api/search-image?query=anime%20swordsman%20in%20ancient%20chinese%20robes%20with%20flowing%20sash%2C%20drifting%20petals%20and%20warm%20sunset%2C%20epic%20wuxia%20hero%20pose%2C%20golden%20warm%20palette%2C%20cinematic%20key%20visual%20illustration&width=600&height=800&seq=manga-cover-06&orientation=portrait",
    count: 21,
    tag: "国漫",
    owner: "青丘画师",
    comicIds: ["shanhai-spirits", "wind-changan", "lone-city-escort", "spirit-contract"],
  },
  {
    id: "scifi",
    name: "科幻脑洞·未来已来",
    desc: "量子学院、机械之心、星际远征……科幻迷的快乐老家，脑洞与硬核设定并存，越看越惊叹。",
    cover: "https://readdy.ai/api/search-image?query=anime%20students%20in%20sci%20fi%20academy%20uniform%20with%20holographic%20gadgets%2C%20bright%20warm%20futuristic%20campus%2C%20energetic%20and%20playful%2C%20golden%20sunlight%2C%20clean%20vibrant%20key%20visual&width=600&height=800&seq=manga-cover-04&orientation=portrait",
    count: 17,
    tag: "科幻",
    owner: "星际漫游",
    comicIds: ["quantum-academy", "star-wanderer", "mechanical-heart", "paper-wonderland"],
  },
  {
    id: "romance",
    name: "恋爱日常·心动与甜",
    desc: "校园与日常里的温柔心动。没有狗血，只有恰到好处的青涩与美好，适合想被甜甜到的小伙伴。",
    cover: "https://readdy.ai/api/search-image?query=anime%20music%20student%20playing%20violin%20in%20a%20blooming%20park%2C%20fresh%20warm%20spring%20light%2C%20cherry%20blossoms%2C%20gentle%20romantic%20mood%2C%20soft%20peach%20palette%2C%20delicate%20illustration&width=600&height=800&seq=manga-cover-13&orientation=portrait",
    count: 12,
    tag: "恋爱",
    owner: "心动便利店",
    comicIds: ["spring-etude", "quantum-academy", "moonlit-street", "cat-manager"],
  },
];

export const faqs: FaqItem[] = [
  {
    q: "妖精漫画网是免费的吗？",
    a: "是的，站内的漫画阅读、收藏、书单整理与标签筛选等核心功能都免费开放。我们会通过合理的运营方式维持服务，始终把阅读体验放在第一位。",
  },
  {
    q: "如何把喜欢的漫画加入我的收藏？",
    a: "打开任意漫画详情页，点击封面下方的「收藏」按钮即可加入个人收藏。之后可在个人书架里按标签或更新时间快速筛选，追更更方便。",
  },
  {
    q: "漫画可以下载离线阅读吗？",
    a: "支持。在漫画详情页选择「下载」并按需要选择章节范围，即可缓存到本地离线阅读，通勤、无网环境也不受影响。",
  },
  {
    q: "书单和标签分别有什么用？",
    a: "标签是作品的天然属性，方便你按题材筛选；书单则是由用户按主题自由整理的合集，例如「治愈系深夜回血书单」。两者配合，找漫效率翻倍。",
  },
  {
    q: "怎么查找一部作品的完整目录？",
    a: "进入漫画详情页即可查看完整章节目录，支持按正序/倒序排列，并会高亮显示你上次的阅读位置，随时接着看。",
  },
  {
    q: "我的追更进度会丢失吗？",
    a: "不会。阅读进度会自动同步到你的账号，换设备登录也能无缝衔接，重新打开自动定位到上次阅读的章节。",
  },
  {
    q: "如何反馈问题或提出建议？",
    a: "你可以在「关于我们」页面找到联系邮箱，或通过站内反馈入口提交意见。我们会认真阅读每一条反馈，持续优化找漫与阅读体验。",
  },
  {
    q: "可以创建自己的书单并分享吗？",
    a: "当然可以。登录后即可创建主题书单、添加作品并生成分享链接，方便把心头好安利给一起追漫的朋友。",
  },
];

export const aboutStats = [
  { value: "1200+", label: "收录作品" },
  { value: "180万", label: "月活跃读者" },
  { value: "3.6万", label: "用户书单" },
  { value: "30+", label: "题材标签" },
];

export function getComic(id: string): MangaComic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByIds(ids: string[]): MangaComic[] {
  return comics.filter((c) => ids.includes(c.id));
}